import React from "react";
//import reusable components
import Header from "../components/Header";
import Footer from "../components/Footer";
//import pages
import Tokenomics from "./Tokenomics";
import Rarity from "./Rarity";
import Faq from "./FAQ";
import Roadmap from "./Roadmap";
//import styling
import "../styles/home.css";

const Home = () => {
  return (
    <section>
      <Header />
      <section className="landing">
        <div className="mobile_landing">
          <div className="content">
            <h1 className="title">Welcome to
YooBs Party</h1>
            <div className="sub">
              <p className="description">
              The YooBs are tired of living in Forests Of Polygon Blockchain, which is why they decided to move to the city to live with humans. Although the Yoobs found the human way of life strange, they enjoyed the internet quite a lot.
                            </p>
            </div>
            <div className="image">
              <img
                loading="lazy"
                src={require("../assets/images/nft_bus.png")}
                alt=""
              />
            </div>
            <div className="social_buttons">
              <a
                className="twitter"
                href="https://twitter.com/YooB_NFTs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../assets/icons/twitter-plain.svg").default}
                  alt=""
                />
                <span>Twitter</span>
              </a>
              <a
                className="discord"
                href="https://discord.gg/QGzVsu3DyE"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../assets/icons/discord-plain.svg").default}
                  alt=""
                />
                <span>Discord</span>
              </a>
            </div>
          </div>
        </div>
        <div className="desktop_landing">
          <div className="content">
            <h1 className="title">Welcome to
YooBs Party</h1>
            <div className="sub">
              <p className="description">
              The YooBs are tired of living in Forests Of Polygon Blockchain, which is why they decided to move to the city to live with humans. Although the Yoobs found the human way of life strange, they enjoyed the internet quite a lot.
                            </p>
            </div>
            <div className="social_buttons">
              <a
                className="twitter"
                href="https://twitter.com/YooB_NFTs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../assets/icons/twitter-plain.svg").default}
                  alt=""
                />
                <span>Twitter</span>
              </a>
              <a
                className="discord"
                href="https://discord.gg/QGzVsu3DyE"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../assets/icons/discord-plain.svg").default}
                  alt=""
                />
                <span>Discord</span>
              </a>
            </div>
          </div>
          <div className="image">
            <img
              loading="lazy"
              src={require("../assets/images/nft_bus.png")}
              alt=""
            />
          </div>
        </div>
      </section>
      <Tokenomics />
      <Rarity />
      <Roadmap />
      <Faq />
      <Footer />
    </section>
  );
};

export default Home;
